import TopRating from "./TopRating";

export default TopRating;
